<div id="login">

    <div class="cmqch-landing">

        <!-- Navbar -->
        <nav class="cmqch-nav">
            <div class="cmqch-nav__brand">
                <img src="../../../../../assets/images/LogoCMQCH.png" alt="CMQCH" class="cmqch-nav__logo">
                <div class="cmqch-nav__brand-text">
                    <span class="cmqch-nav__brand-title">CMQCH</span>
                    <span class="cmqch-nav__brand-subtitle">Colegio de Microbiólogos y Químicos Clínicos</span>
                </div>
            </div>
            <div class="cmqch-nav__links">
                <a (click)="scrollTo('cmqchHero')">Inicio</a>
                <a (click)="scrollTo('cmqchServicios')">Servicios</a>
                <a (click)="scrollTo('cmqchAcerca')">Nosotros</a>
            </div>
            <button type="button" class="cmqch-nav__cta" (click)="abrirLogin()">
                <mat-icon>login</mat-icon> Iniciar Sesión
            </button>
        </nav>

        <!-- Hero -->
        <header class="cmqch-hero" id="cmqchHero">
            <div class="cmqch-hero__pattern"></div>
            <div class="cmqch-hero__content">
                <span class="cmqch-hero__badge">✦ Portal de afiliados 100% digital</span>
                <h1 class="cmqch-hero__title">Colegio de Microbiólogos y Químicos Clínicos de Honduras</h1>
                <p class="cmqch-hero__subtitle">Portal de Laboratorios</p>
                <p class="cmqch-hero__desc">
                    Gestiona tu afiliación, consulta tu expediente y estado de cuenta, su nueva plataforma segura y completamente digital.
                </p>

                <div class="cmqch-hero__actions">
                    <button type="button" class="cmqch-hero__cta-primary" (click)="abrirLogin()">
                        <mat-icon>login</mat-icon> Iniciar Sesión
                    </button>
                    <button type="button" class="cmqch-hero__cta-secondary" (click)="scrollTo('cmqchServicios')">
                        Ver Servicios <mat-icon>arrow_forward</mat-icon>
                    </button>
                </div>

                <div class="cmqch-hero__stats">
                    <div class="cmqch-hero__stat">
                        <span class="cmqch-hero__stat-value">CMQCH</span>
                        <span class="cmqch-hero__stat-label">Honduras</span>
                    </div>
                    <div class="cmqch-hero__stat">
                        <span class="cmqch-hero__stat-value">24/7</span>
                        <span class="cmqch-hero__stat-label">Disponible</span>
                    </div>
                    <div class="cmqch-hero__stat">
                        <span class="cmqch-hero__stat-value">Seguro</span>
                        <span class="cmqch-hero__stat-label">Certificado</span>
                    </div>
                </div>
            </div>

            <button type="button" class="cmqch-hero__scroll" (click)="scrollTo('cmqchServicios')">
                <span>Descubre más</span>
                <mat-icon>expand_more</mat-icon>
            </button>
        </header>

        <!-- Servicios -->
        <section class="cmqch-servicios" id="cmqchServicios">
            <span class="cmqch-servicios__tag">Servicios</span>
            <h2 class="cmqch-servicios__title">¿Qué puedes hacer en el portal?</h2>
            <p class="cmqch-servicios__desc">Todo lo que necesitas para gestionar tu afiliación al colegio, en un solo lugar.</p>

            <div class="cmqch-servicios__grid">
                <div class="cmqch-servicio cmqch-servicio--slate">
                    <div class="cmqch-servicio__icon"><i class="fas fa-id-card-alt"></i></div>
                    <h3>Expediente Digital</h3>
                    <p>Consulta y actualiza la información de tu expediente como afiliado.</p>
                </div>
                <div class="cmqch-servicio cmqch-servicio--green">
                    <div class="cmqch-servicio__icon"><i class="fas fa-file-invoice-dollar"></i></div>
                    <h3>Estado de Cuenta</h3>
                    <p>Revisa tus pagos, cobros pendientes y realiza pagos en línea.</p>
                </div>
       
                <div class="cmqch-servicio cmqch-servicio--amber">
                    <div class="cmqch-servicio__icon"><i class="fas fa-list"></i></div>
                    <h3>Solicitudes y Certificados</h3>
                    <p>Solicita certificados y da seguimiento a tus trámites.</p>
                </div>
            </div>
        </section>

        <!-- Acerca -->
        <section class="cmqch-acerca" id="cmqchAcerca">
            <img src="../../../../../assets/images/LogoCMQCH.png" alt="CMQCH" class="cmqch-acerca__logo">
            <h2 class="cmqch-acerca__title">Colegio de Microbiólogos y Químicos Clínicos de Honduras</h2>
            <p class="cmqch-acerca__desc">
                Somos la entidad que agremia y certifica a los laboratorios de la
                microbiología y química clínica en Honduras, promoviendo la excelencia y la
                actualización de información.
            </p>
            <button type="button" class="cmqch-acerca__cta" (click)="abrirLogin()">Ingresar al portal</button>
        </section>

        <footer class="cmqch-footer">
            <span>© {{ anioActual }} Colegio de Microbiólogos y Químicos Clínicos de Honduras</span>
        </footer>
    </div>

    <div class="cmqch-modal-backdrop" *ngIf="mostrarModal" (click)="cerrarLogin()">
        <div class="cmqch-modal" (click)="$event.stopPropagation()">
            <button type="button" class="cmqch-modal__close" (click)="cerrarLogin()">
                <mat-icon>close</mat-icon>
            </button>

            <ng-container *ngIf="cambioPass === false">
                <form class="cmqch-form" [formGroup]="formLogin" (ngSubmit)="login()">
                    <img src="../../../../../assets/images/LogoCMQCH.png" alt="CMQCH" class="cmqch-form__logo">
                    <h1 class="cmqch-form__title">Iniciar sesión</h1>
                    <p class="cmqch-form__subtitle">Portal de Laboratorios</p>

                    <mat-form-field appearance="outline" class="cmqch-form__field" tourAnchor="correo">
                        <mat-label>Usuario</mat-label>
                        <input autocomplete="off" matInput minlength="5" required formControlName="usuario">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="cmqch-form__field">
                        <mat-label>Contraseña</mat-label>
                        <input matInput [type]="hide ? 'password' : 'text'" placeholder="Contraseña"
                            formControlName="clave" required autocomplete="off">
                        <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>

                    <div class="cmqch-form__links">
                        ¿Has olvidado tu <a (click)="recuperarUsuario()">usuario</a> o
                        <a (click)="cambioPass = true">contraseña</a>?
                    </div>

                    <button type="submit" class="cmqch-form__submit" mat-raised-button>Entrar</button>
                </form>
            </ng-container>

            <ng-container *ngIf="cambioPass === true">

                <ng-container *ngIf="vistaCambioPass === 'numeroColegiacion'">
                    <h2 class="cmqch-recover__title">Recupera tu contraseña</h2>

                    <mat-form-field appearance="outline" class="cmqch-form__field">
                        <mat-label>Número Colegiación</mat-label>
                        <input matInput type="text" placeholder="Número Colegiación" [formControl]="numeroColegiacion"
                            required autocomplete="off">
                    </mat-form-field>

                    <app-loading [data]="4" *ngIf="(authService.responseCargando$ | async)"></app-loading>

                    <div class="cmqch-recover__actions" *ngIf="!(authService.responseCargando$ | async)">
                        <button mat-raised-button class="buttonSecundary" (click)="regresarCambioPass()">Volver</button>
                        <button mat-raised-button class="buttonPrincipal" (click)="confirmarDatosColegiacion()">Siguiente</button>
                    </div>
                </ng-container>

                <ng-container *ngIf="vistaCambioPass === 'confirmarDatos'">
                    <h2 class="cmqch-recover__title">Recupera tu contraseña</h2>
                    <p class="cmqch-recover__hint">Debes completar por lo menos dos de los campos solicitados. Ejemplo: DNI y correo electrónico</p>

                    <form [formGroup]="formRecuperarPass">
                        <mat-form-field appearance="outline" class="cmqch-form__field">
                            <mat-label>DNI</mat-label>
                            <input matInput type="text" placeholder="Número DNI" formControlName="noIdentificacion"
                                required autocomplete="off">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="cmqch-form__field">
                            <mat-label>Celular Registrado {{datosUsuario?.celular}}</mat-label>
                            <input matInput type="text" placeholder="Numero Colegiación {{datosUsuario?.celular}}"
                                formControlName="celular" autocomplete="off">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="cmqch-form__field">
                            <mat-label>Teléfono Registrado {{datosUsuario?.telefono}}</mat-label>
                            <input matInput type="text" placeholder="Numero Colegiación {{datosUsuario?.telefono}}"
                                formControlName="telefono" autocomplete="off">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="cmqch-form__field">
                            <mat-label>Correo Electrónico {{datosUsuario?.correoElectronico}}</mat-label>
                            <input matInput type="text" placeholder="Numero Colegiación {{datosUsuario?.correoElectronico}}"
                                formControlName="correoElectronico" autocomplete="off">
                        </mat-form-field>
                    </form>

                    <app-loading [data]="4" *ngIf="(authService.responseCargando$ | async)"></app-loading>

                    <div class="cmqch-recover__actions" *ngIf="!(authService.responseCargando$ | async)">
                        <button mat-raised-button class="buttonSecundary" (click)="regresarCambioPass()">Cancelar</button>
                        <button mat-raised-button class="buttonPrincipal" (click)="validarFormularioCambioPass()">Siguiente</button>
                    </div>

                    <div class="cmqch-recover__info" *ngIf="datosUsuario?.informacion != ''">
                        {{datosUsuario?.informacion}}
                    </div>
                </ng-container>

            </ng-container>
        </div>
    </div>

</div>
